/* eslint-disable @typescript-eslint/ban-ts-comment */
import { SearchClient } from 'algoliasearch';
import { liteClient as algoliasearch, SearchQuery } from 'algoliasearch/lite';
import { ALGOLIA_APP_ID, ALGOLIA_APP_KEY, ALGOLIA_INDEX_NAME } from 'constants/algolia';
import {
  createNullCache, createBrowserLocalStorageCache, createMemoryCache, createFallbackableCache,
} from '@algolia/client-common';
import { cookiesIdHandler } from 'middleware/cookieMiddlewareIdHandler';
import aa from 'search-insights';

if (!ALGOLIA_APP_ID || !ALGOLIA_APP_KEY || !ALGOLIA_INDEX_NAME) {
  throw new Error('Algolia Application ID, API Key and Index must be defined in .env');
}

const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_APP_KEY, {
  requestsCache: createMemoryCache({ serializable: false }),
  responsesCache: createFallbackableCache({
    caches: [
      createBrowserLocalStorageCache({
        key: 'algolia-responses',
        timeToLive: 600,
      }),
      createMemoryCache(),
      createNullCache(),
    ],
  }),
});

const searchClient: SearchClient = {
  ...algoliaClient,
  // @ts-ignore
  search(requests: SearchQuery[]) {
    const searchBarRequest = requests.find((request) => request.indexName === ALGOLIA_INDEX_NAME);
    // @ts-ignore
    if (searchBarRequest?.params?.query === '') {
      return Promise.resolve();
    }
    return algoliaClient.search(requests);
  },
};

export default searchClient;

let sessionId = cookiesIdHandler().getSessionId();
if (!sessionId) sessionId = cookiesIdHandler().createSessionId();

const initInsightsAlgolia = () => {
  aa('init', {
    appId: ALGOLIA_APP_ID,
    apiKey: ALGOLIA_APP_KEY,
  });

  aa('setUserToken', sessionId);
};

initInsightsAlgolia();
export const userTokenAlgolia = sessionId;

export const setAuthenticatedUserTokenAlgolia = () => {
  aa('setAuthenticatedUserToken', sessionId);
};
